import { EventEmitter, Injectable, Output } from '@angular/core';
import { ConfirmationDto } from './types';

@Injectable({
  providedIn: 'root'
})
export class McbConfirmationService {

  // private confirmationModel = new Subject<ConfirmationDto>();
  // confirmModelConfirmed = this.confirmationModel.asObservable();
  @Output() confirmed: EventEmitter<ConfirmationDto> = new EventEmitter<ConfirmationDto>();


  constructor() {
  }

  confirm(data: ConfirmationDto) {
    this.confirmed.emit(data);
  }
}
